<template>
    <v-container v-if="videoItem.video_source" fluid class="primary-transparent-5">
        <v-container>
            <v-layout row wrap>
                <v-flex xs12>
                    <p class="text-xs-center text-uppercase headline font-weight-bold white--text">
                        {{ 'PRODUCT_VIDEO_TITLE' | translation }}
                    </p>

                    <video-element
                        class="product-video"
                        :id="videoItem.video_id"
                        :source="videoItem.video_source"
                    />
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>

<style>
.product-video {
    border: 9px solid white;
}
</style>

<script>
import VideoElement from '@breakmedia/prime-vue-page/src/page-components/video/VideoElement';
import {mapState} from 'vuex';

export default {
    name: 'ProductVideo',
    components: {
        VideoElement,
    },
    computed: {
        ...mapState('Product', {
            videoItem(state) {
                let result = {};

                if (state.product && state.product.images.product_images) {
                    state.product.images.product_images.some(i => {
                        if (i.video_source) {
                            result = i;
                            return true;
                        }
                    });
                }

                return result;
            },
        }),
    },
};
</script>